<template>
  <v-dialog
    v-model="show"
    width="380px"
  >
    <v-card class="pa-4 pb-0" :loading="loading">
      <h3>Create Account</h3>
      <template v-if="!emailSend">
        <p class="title font-weight-light">
          Please enter an email address for your account.
        </p>
        <v-text-field
          v-model="emailAddress"
          type="text"
          label="Email"
          :error="!!error"
          :error-messages="error"
          :disabled="loading"
          required
        ></v-text-field>
      </template>
      <template v-else>
        <p class="title font-weight-light">
          A verification link has been sent to the provided email address. You will
          need to follow the link in order to continue.
        </p>
      </template>

      <v-card-actions>
        <v-btn
          v-if="!emailSend"
          text
          @click="show = false"
          :disabled="loading"
        >
          Cancel
        </v-btn>
        <v-btn
          v-if="!emailSend"
          tile
          color="primary"
          class="ml-auto"
          :disabled="loading"
          @click="sendAuthLink"
        >
          Next
        </v-btn>
        <v-btn
          v-if="emailSend"
          tile
          text
          class="ml-auto"
          :disabled="loading"
          @click="show = false"
        >
          Close
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  const fb = require('@/core/config/firebase.js');

  export default {
    name: 'Login',
    metaInfo: {
      title: 'Login',
    },
    computed: {
    },
    props: {
        email: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch:{
      emailAddress(newValue){
        this.$emit('update:email', newValue)
      }
    },
    data() {
      return {
        emailAddress: this.email,
        emailSend: false,
        error: undefined,
        show: false,
        loading: false,
      }
    },
    methods: {
      showModal(email) {
        this.emailAddress = email;
        this.show = true;
      },
      async sendAuthLink() {
        this.loading = true;
        this.error = undefined;
        try {
            await fb.auth.sendSignInLinkToEmail(this.emailAddress, fb.actionCodeSettings);
            window.localStorage.setItem('emailForSignIn', this.emailAddress);
            this.emailSend = true;
        } catch (err) {
            this.error = err.message;
        }

        this.loading = false;
      }
    }
  }
</script>
<style>
  .login-container {
    height: 100%;
  }
</style>
